<template>
  <div class="endContent">
    <div class="endContent_circle">
      <img class="endContent_circle_img" src="http://i.imgur.com/Izl594b.png">
    </div>
  </div>
</template>

<script>
  export default {}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import 'endContent.scss';
</style>



// WEBPACK FOOTER //
// endContent.vue?647f0f78